//#region IMPORT
import React, { useEffect } from 'react';
/** Components Import */
import {
  Stack,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  CardContent,
  CardHeader,
  ListItemButton,
  ListItemIcon,
  ListItemAvatar,
} from '@mui/material';
import { Switch } from '../../Components/MUIs';
/** Icons Import */
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../Reducer/NavBarInfoReducer';
import { useDispatch } from 'react-redux';
//#endregion

function M_Alarm(props) {
  const { lanInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('appBarDefault'));
  }, [dispatch]);
  return (
    <Stack
      spacing={1}
      sx={{ bgcolor: '#ffffffff', height: 'calc(100vh - 124px)' }}
    >
      <Box sx={{ p: 1 }}>
        <Box
          sx={{
            boxShadow:
              '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
          }}
        >
          <CardHeader
            sx={{ mt: 2 }}
            titleTypographyProps={{
              textAlign: 'center',
              fontWeight: 700,
            }}
            title={
              lanInfo.length > 0
                ? lanInfo.filter((f) => f.lanId === 'AlarmSetting')[0]?.lanNm ||
                '알림 설정'
                : '알림 설정'
            }
          />
          <CardContent>
            <List>
              {Array.isArray(props.settings) && props.settings.length > 0 ? (
                props.settings.map((item, index) => {
                  return (
                    <React.Fragment key={item.asId || index}>
                      <ListItem sx={{ py: 1 }}>
                        <ListItemButton
                          sx={{
                            p: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                          disableRipple
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              flex: 1,
                            }}
                          >
                            <ListItemAvatar sx={{ minWidth: 'auto', mr: 2 }}>
                              <NotificationsIcon
                                sx={{
                                  color:
                                    item.useYn === 'Y' ? '#2CA900' : '#B0B4BA',
                                }}
                              />
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{
                                    fontWeight: item.useYn === 'Y' ? 600 : 400,
                                    color:
                                      item.useYn === 'Y'
                                        ? '#000000'
                                        : '#666666',
                                  }}
                                >
                                  {item.codeNm}
                                </Typography>
                              }
                            />
                          </Box>
                          <ListItemIcon sx={{ minWidth: 'auto' }}>
                            <Switch
                              name=""
                              checked={item.useYn === 'Y'}
                              onChange={(e) => {
                                props.HandleSwitchChange(item, e);
                              }}
                            />
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                      {index < props.settings.length - 1 && (
                        <Divider variant="middle" />
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          textAlign: 'center',
                          color: '#B0B4BA',
                          py: 2,
                        }}
                      >
                        설정할 알림이 없습니다.
                      </Typography>
                    }
                  />
                </ListItem>
              )}
            </List>
          </CardContent>
        </Box>
      </Box>
    </Stack>
  );
}

export default M_Alarm;
